import gql from "graphql-tag";

export const GET_PRODUCTS = gql`
  query getProducts($productFinderId: String!, $answers: String!) {
    products(productFinderId: $productFinderId, answers: $answers) {
      name
      url
      image_url
      price
      special_price
      rating
      match
    }
  }
`;
